import { render, staticRenderFns } from "./ImgGoodsSelectCheckbox.vue?vue&type=template&id=b3dc4fb6&scoped=true&"
import script from "./ImgGoodsSelectCheckbox.vue?vue&type=script&lang=js&"
export * from "./ImgGoodsSelectCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./ImgGoodsSelectCheckbox.vue?vue&type=style&index=0&id=b3dc4fb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3dc4fb6",
  null
  
)

export default component.exports